import { InjectionToken } from '@angular/core';
import { Checkout } from '@df/checkout/checkout.interfaces';

export namespace NCheckout {
    export const DEFAULT_OPTIONS: IModuleOptions = {
        // steps
        steps: ['account', 'delivery', 'payment'],
        restoreLastStep: true,

        fieldsNotPreventingDefaultAddress: ['id', 'country_id'],

        // ACCOUNT
        useCheckoutEndpoint: false,

        // ADDRESSES
        autoPickAnyAddress: true,

        // SHIPPING METHODS
        collectionMethods: ['storepickup_storepickup', 'storepickup'],
        autoPickShippingMethod: false,
        autoPickShippingMethodIfOnlyOneAvailable: false,
        autoPickCheepestShippingMethod: false,

        // PAYMENT METHODS
        autoPickPaymentMethod: false,
        autoPickPaymentMethodIfOnlyOneAvailable: false,
        autoPickSavedCard: true,
        forceBillingToShipping: false,

        // CHECKOUT DEFAULTS
        defaults: {
            // account: {},
            newsletter: false,
            address: {
                billing: <Checkout.IAddress>{},
                shipping: <Checkout.IAddress>{}
            },
            gift: {},
            multishipping: false,
            account: {},
            billing: {
                to_shipping: true
            },
            shipping: {
                method: undefined
            },
            payment: {},
            custom: {}
        }
    };

    export const OPTIONS = new InjectionToken<IModuleOptions>('DF_CHECKOUT_OPTIONS', {
        providedIn: 'root',
        factory: () => DEFAULT_OPTIONS
    });

    export interface IModuleOptions {
        /**
         * Array with step ids
         * @type {string[]}
         */
        steps: string[];
        /**
         * Array of address fields which doesn't prevent selecting default address
         * @type {string[]}
         */
        fieldsNotPreventingDefaultAddress: string[];

        // ACCOUNT
        useCheckoutEndpoint: boolean;

        // ADDRESS
        autoPickAnyAddress: boolean;

        // SHIPPING METHODS

        /**
         * Array of collection type methods
         * @type {string[]}
         */
        collectionMethods: string[];
        /**
         * If true then checkout will automatically pick shipping method
         * if string[] then only one of given codes will be picked
         * if function it will be called
         * @type {Boolean}
         */
        autoPickShippingMethod:
            | boolean
            | string[]
            | ((component: Checkout.ICheckoutShippingMethodsComponent) => Checkout.IShippingMethod[]);
        /**
         * If true then checkout will automatically pick shipping method if only one available
         * @type {Boolean}
         */
        autoPickShippingMethodIfOnlyOneAvailable: boolean;
        /**
         * If true then checkout will automatically pick cheampest (may be combined with autoPickShippingMethod)
         * @type {Boolean}
         */
        autoPickCheepestShippingMethod: boolean;
        /**
         * Array of methods allowed for nominated day delivery
         * @type {string[]}
         */
        nominatedDayMethods?: string[];

        // PAYMENT METHODS

        /**
         * If true then checkout will automatically pick payment method
         * @type {Boolean}
         */
        autoPickPaymentMethod: boolean | string[] | ((component: Checkout.ICheckoutPaymentMethodsComponent) => Checkout.IPaymentMethod[]);
        /**
         * If true then checkout will automatically pick payment method if only one available
         * @type {Boolean}
         */
        autoPickPaymentMethodIfOnlyOneAvailable: boolean;
        /**
         * If true then checkout will automatically pick saved card as payment method
         * @type {Boolean}
         */
        autoPickSavedCard: boolean;

        /**
         * If billing to shipping should be true even if default addresses are different
         */
        forceBillingToShipping: boolean;

        // CHECKOUT DEFAULTS
        /**
         * Default values for checkout data
         * Note that:
         * 1. nothing that comes from BE is overwritten,
         * 2. localConfig.defaultCheckoutData can be used too with higher priority than this
         *
         */
        defaults: Checkout.IQuoteDataPartial;

        /**
         * If we should restore last visited step when entering checkout in the same session
         * @type {boolean}
         */
        restoreLastStep?: boolean;
    }
}
